import { useNavigate, useParams } from "react-router";
import { useStoreState } from "../../store";
import { useAuth } from "../../utility/useAuth";
import {
  LabelText,
  SmallLabelText,
  StyledFactoryAcceptanceInspectionPage,
  TitleLabelText,
} from "./FactoryAcceptanceInspectionPage.styles";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import AsyncModal from "../../components/Modals/AsyncModal/AsyncModal";
import { BarCodeScannerPanel } from "../../components/BarCodeScannerPanel/BarCodeScannerPanel";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import {
  ButtonComponent,
  CheckBoxComponent,
} from "@syncfusion/ej2-react-buttons";
import { FactoryAcceptanceInspectionReport } from "../../types/reportChecklists/FactoryAcceptanceInspectionReport";
import {
  createTicket,
  getDocumentContent,
  getDocuments,
  getOption,
  getUsers,
  lockAction,
  printTemplate,
  sendEmail,
  unlockAction,
  uploadDocument,
} from "../../services/ApiService";
import { RecomendationType } from "../../types/reportChecklists/RecomendationType";
import { InpectionItem } from "../../types/reportChecklists/InspectionItem";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { InspectionStatusType } from "../../types/reportChecklists/InspectionStatusType";
import { shortDateFormat } from "../../utility/dateHelpers";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import { Ticket } from "../../types/reportChecklists/Ticket";
import { PrintRequest } from "../../types/PrintRequest";
import { InspectorRole } from "../../types/InspectorRole";
import { EmailMessage } from "../../types/EmailMessage";

export const FactoryAcceptanceInspectionPage: React.FC = () => {
  const auth = useAuth();
  const user = useStoreState((state) => state.user);
  const { sequence } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  const [productionNumber, setProductionNumber] = useState<string>();
  const [quantity, setQuantity] = useState<number>(1);
  const [sequenceNumber, setSequenceNumber] = useState<string>();
  const [batch, setBatch] = useState<number>(1);
  const [iteration, setIteration] = useState<string>("A");
  const [status, setStatus] = useState<string>();
  const [assemblyDrawingNumber, setAssemblyDrawingNumber] = useState<string>();
  const [revision, setRevision] = useState<string>();
  const [recommendation, setRecommendation] = useState<string>();
  const [nonConformanceReportRef, setNonConformanceReportRef] =
    useState<string>();
  const [reworkDescription, setReworkDescription] = useState<string>();
  const [documentCheckListItems, setDocumentCheckListItems] = useState<
    InpectionItem[]
  >([]);
  const [visualCheckListItems, setVisualCheckListItems] = useState<
    InpectionItem[]
  >([]);
  const [inspectorSignature, setInspectorSignature] = useState<string>();
  const [inspectorSignDate, setInspectorSignDate] = useState<Date | undefined>(
    undefined
  );
  const [qualityRepresentiveSignature, setQualityRepresentiveSignature] =
    useState<string>();
  const [qualityRepresentiveSignDate, setQualityRepresentiveSignDate] =
    useState<Date | undefined>(undefined);
  const [warehouseRepresentiveSignature, setWarehouseRepresentiveSignature] =
    useState<string>();
  const [warehouseRepresentiveSignDate, setWarehouseRepresentiveSignDate] =
    useState<Date | undefined>(undefined);

  const [printerName, setPrinterName] = useState<string>();
  const [lockInspectionMinutes, setLockInspectionMinutes] =
    useState<number>(10);

  const [readOnly, setReadOnly] = useState<boolean>(false);

  const [canSumbit, setCanSubmit] = useState<boolean>(false);

  let btnProductionNumber: ButtonComponent | null;

  const recomendations = [
    RecomendationType[RecomendationType.TotalRejection],
    RecomendationType[RecomendationType.PartialRejection],
    RecomendationType[RecomendationType.Approval],
  ];

  const reportType = "factory-acceptance-inspection";
  const reportDescription = "Factory Acceptance Test inspection";

  const documentCheckList = [
    "Confirm the ‘as built’ Standard and Drawing Status",
  ];

  const visualCheckList = [
    "Tubing free from scratches, knocks, dents etc",
    "Fitting free from scratches, knocks, dents etc",
    "Tubing ends free from burrs",
    "Tubing free from contamination / debris",
    "Suitable insertion depth of tubing into ferrule",
    "Assembly cleaned with isopropyl alcohol",
    "White cloth (if required) 24hr time clock (capture start / finish time)",
  ];

  useEffect(() => {
    const visualCheckItems = visualCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setVisualCheckListItems(visualCheckItems);
    const documentCheckItems = documentCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setDocumentCheckListItems(documentCheckItems);
    setInspectorSignature(user.info.name ?? user.fullName);
    setInspectorSignDate(new Date());

    getOption(auth, `LabelPrinter:${user.info.printLocation}`).then(
      (option) => {
        setPrinterName(option);
      }
    );

    getOption(auth, `LockInspectionMinutes`).then((option) => {
      if (option) {
        setLockInspectionMinutes(Number(option));
      }
    });
  }, []);

  useEffect(() => {
    if (sequence) {
      if (
        user.info.inspection !==
          InspectorRole[InspectorRole.QualityRepresentive] &&
        user.info.inspection !==
          InspectorRole[InspectorRole.WarehouseRepresentive]
      ) {
        setError(
          "You need to be Quality or Warehouse Representive to countersign the report."
        );
        return;
      }

      if (
        user.info.inspection ===
        InspectorRole[InspectorRole.QualityRepresentive]
      ) {
        setQualityRepresentiveSignature(user.info.name ?? user.fullName);
        setQualityRepresentiveSignDate(new Date());
      } else if (
        user.info.inspection ===
        InspectorRole[InspectorRole.WarehouseRepresentive]
      ) {
        setWarehouseRepresentiveSignature(user.info.name ?? user.fullName);
        setWarehouseRepresentiveSignDate(new Date());
      }
      loadReport(sequence, false);
    }
  }, [sequence]);

  useEffect(() => {
    if (productionNumber) {
      const sequenceNumber = `${productionNumber}-${batch}-${iteration}${
        status ? `-${status}` : ""
      }`;
      setSequenceNumber(sequenceNumber);
    }
  }, [productionNumber, batch, iteration, status]);

   useEffect(() => {
      const documentStatus = validateItems(documentCheckListItems);
      const visualStatus = validateItems(visualCheckListItems);
      setStatus(undefined);
      setCanSubmit(false);
      if (
        !productionNumber ||
        !revision || 
        !assemblyDrawingNumber
      ) {
        return;
      }
      if (
        documentStatus === true &&
        visualStatus === true &&
        productionNumber &&
        recommendation === RecomendationType[RecomendationType.Approval]
      ) {
        setStatus("P");
        setCanSubmit(true);
      }
      if (
        productionNumber &&
        (documentStatus === false ||
          visualStatus === false ) &&
        (recommendation === RecomendationType[RecomendationType.TotalRejection] ||
          iteration === "D")
      ) {
        setStatus("F");
        setCanSubmit(true);
      } else if (
        productionNumber &&
        (documentStatus === false ||
          visualStatus === false ) &&
        (recommendation ===
          RecomendationType[RecomendationType.PartialRejection] ||
          recommendation === RecomendationType[RecomendationType.LocalRework])
      ) {
        setStatus("R");
        setCanSubmit(true);
      }
    }, [
      productionNumber,
      assemblyDrawingNumber,
      revision,
      documentCheckListItems,
      visualCheckListItems,
      recommendation,
    ]);

  function loadReport(sequence: string, rework: boolean) {
    if (sequence && documentCheckListItems && visualCheckListItems) {
      const parts = sequence.split("-");
      const partNumber = parts
        .slice(0, parts.length - 3)
        .join("-")
        .toUpperCase();
      const batch = Number(parts[parts.length - 3]);
      const iteration = parts[parts.length - 2].toUpperCase();
      const status = parts[parts.length - 1];
      const reportName = `${batch}-${iteration}-${status}`;

      const newIteration = rework
        ? String.fromCharCode(iteration.charCodeAt(0) + 1)
        : iteration;
      if (!rework) {
        lockAction(
          auth,
          `${partNumber} ${reportDescription}`,
          lockInspectionMinutes
        ).catch((error) => {
          setError(`${error.response.data}`);
          return;
        });
      }

      getReport(partNumber.toLowerCase(), reportName.toLowerCase()).then(
        (report) => {
          if (!report) {
            setError("Failed to load the report");
            return;
          }

          const signedBy = user.info.name ?? user.fullName;
          if (!rework && report?.inspectorSignature === signedBy) {
            setError(
              "You can't countersign the report that you already signed"
            );
            return;
          }

          setProductionNumber(report?.productionNumber);
          setAssemblyDrawingNumber(report?.assemblyDrawingNumber);
          setRevision(report?.revision);
          setQuantity(report?.quantity);

          // Workaround for UI Grid issue
          if (
            report.documentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            documentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setDocumentCheckListItems(
              report?.documentCheckListItems ?? documentCheckListItems
            );
          }

          // Workaround for UI Grid issue
          if (
            report.visualCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            visualCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setVisualCheckListItems(
              report?.visualCheckListItems ?? visualCheckListItems
            );
          }

          setRecommendation(report?.recommendation);
          //setBatchIdentification(report?.batchIdentification);
          setNonConformanceReportRef(report?.nonConformanceReportRef);
          setReworkDescription(report?.reworkDescription);

          if (rework) {
            setInspectorSignature(user.info.name ?? user.fullName);
            setInspectorSignDate(new Date());
          } else {
            setInspectorSignature(report?.inspectorSignature);
            setInspectorSignDate(report?.inspectorSignDate);
          }

          if (report?.qualityRepresentiveSignature) {
            setQualityRepresentiveSignature(
              report?.qualityRepresentiveSignature
            );
            setQualityRepresentiveSignDate(report?.qualityRepresentiveSignDate);
          }

          if (report?.warehouseRepresentiveSignature) {
            setWarehouseRepresentiveSignature(
              report?.warehouseRepresentiveSignature
            );
            setWarehouseRepresentiveSignDate(
              report?.warehouseRepresentiveSignDate
            );
          }

          setProductionNumber(partNumber);
          setBatch(batch);
          setIteration(newIteration);
          setStatus(status);
          setSequenceNumber(sequence.toUpperCase());
        }
      );
    }
  }

  const validateItems = (
    inspectionItems: InpectionItem[]
  ): boolean | undefined => {
    if (
      inspectionItems?.some(
        (it) => it.status === InspectionStatusType[InspectionStatusType.Reject]
      )
    ) {
      return false;
    }

    if (
      inspectionItems?.every(
        (it) =>
          it.status === InspectionStatusType[InspectionStatusType.Pass] ||
          it.status === InspectionStatusType[InspectionStatusType.Rework]
      )
    ) {
      return true;
    }
    return undefined;
  };

  const documentCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (documentCheckListItems) {
              const items = [
                ...documentCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setDocumentCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const visualCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (visualCheckListItems) {
              const items = [
                ...visualCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setVisualCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const scanProductionNumberClick = async (event: any) => {
    const dataResult = await AsyncModal.open<string>({
      onHide: () => console.log("On hide"),
      cancelValue: "",
      confirmValue: "",
      children: <BarCodeScannerPanel />,
    });

    if (dataResult) {
      if (isNaN(Number(dataResult))) {
        ToastUtility.show(
          `The Production Order should be numeric`,
          "Error",
          2000
        );
        return;
      }

      try {
        await lockAction(
          auth,
          `${dataResult} ${reportDescription}`,
          lockInspectionMinutes
        );
      } catch (error: any) {
        setError(`${error.response.data}`);
        return;
      }

      const batch = await getProductionOrderBatch(dataResult);
      if (batch[0]) {
        setBatch(batch[0]);
      } else if (batch[1]) {
        loadReport(`${dataResult}-${batch[1]}`, true);
      }

      setProductionNumber(dataResult);
    }
  };

  function handleError(error: any, prefix?: string) {
    const message = `${prefix} Error: ${error}`;
    console.error(message);
    ToastUtility.show(message, "Error", 2000);
  }

  async function getReport(
    productionOrder: string,
    report: string
  ): Promise<FactoryAcceptanceInspectionReport | undefined> {
    try {
      const result = await getDocumentContent(
        auth,
        `${reportType}-reports-${productionOrder}`,
        report
      );
      return JSON.parse(
        await result.text()
      ) as FactoryAcceptanceInspectionReport;
    } catch (error) {
      handleError(error, "Failed to retrieve report");
    }
    return undefined;
  }

  async function getProductionOrderBatch(
    productionOrder: string
  ): Promise<[number | undefined, string | undefined]> {
    try {
      const reports = (
        await getDocuments(
          auth,
          undefined,
          `${reportType}-reports-${productionOrder.toLowerCase()}`,
          true
        )
      ).map((d) => {
        return {
          batch: Number(d.split("\\")[1].split("-")[0]),
          iteration: d.split("\\")[1].split("-")[1],
          status: d.split("\\")[1].split("-")[2],
        };
      });
      //const maxBatch = Math.max(...reports.map((o) => o.batch), 0);
      if (reports?.length > 0) {
        const lastReport = reports.reduce(
          ([max], item) => [
            max.batch * 100 + max.iteration.charCodeAt(0) <
            item.batch * 100 + item.iteration.charCodeAt(0)
              ? item
              : max,
          ],
          [reports[0]]
        );

        if (lastReport?.length > 0 && lastReport[0].status === "r") {
          return [
            undefined,
            `${lastReport[0].batch}-${lastReport[0].iteration}-${lastReport[0].status}`,
          ];
        }

        return [lastReport[0].batch + 1, undefined];
      }

      //return Math.max(...reports.map((o) => o.batch), 0) + 1;
    } catch (error) {
      handleError(error, "Failed to get reports");
    }
    return [1, undefined];
  }

  const printLabel = async (report: FactoryAcceptanceInspectionReport) => {
    if (!printerName) {
      return;
    }

    const substr: {
      [key: string]: string;
    } = {};

    Object.entries(report).forEach(
      ([key, value]) =>
        (substr[`Report.${key}`] =
          value instanceof Date === true
            ? shortDateFormat(value?.toString() ?? "")
            : value.toString() ?? "")
    );

    console.log(JSON.stringify(substr));

    const request: PrintRequest = {
      templateName: `templates-labelprinter\\factoryacceptanceinspectionreport.xml`,
      substrings: substr,
      noLabels: 1,
      printerName: printerName,
      location: user.info.printLocation,
    };

    try {
      const data = await printTemplate(auth, request);
      ToastUtility.show("The print job sent to the spooler.", "Info", 2000);
    } catch (error) {
      handleError(error, "Failed to print label operation.");
    }
  };

  const onSubmit = async (event: any) => {
    const report: FactoryAcceptanceInspectionReport = {
      productionNumber: productionNumber ?? "",
      quantity: quantity,
      assemblyDrawingNumber: assemblyDrawingNumber ?? "",
      revision: revision ?? "",
      documentCheckListItems: documentCheckListItems,
      visualCheckListItems: visualCheckListItems,
      recommendation: recommendation ?? "",
      nonConformanceReportRef: nonConformanceReportRef,
      reworkDescription: reworkDescription,
      inspectorSignature: inspectorSignature ?? "",
      inspectorSignDate: inspectorSignDate ?? new Date(),
    };

    if (
      !nonConformanceReportRef &&
      (recommendation === RecomendationType[RecomendationType.TotalRejection] ||
        recommendation ===
          RecomendationType[RecomendationType.PartialRejection])
    ) {
      const ticket: Ticket = {
        subject: `FAILED FACTORY ACCEPTANCE TEST ${productionNumber}-${batch}-${iteration}`,
        content: reworkDescription!,
      };
      report.nonConformanceReportRef = await createTicket(auth, ticket);
    }

    const blob = new Blob([JSON.stringify(report, null, 2)], {
      type: "application/json",
    });

    const reportName = `${batch}-${iteration}${status ? `-${status}` : ""}`;

    try {
      await uploadDocument(
        auth,
        `${reportType}-reports-${productionNumber}`,
        reportName,
        blob
      );

      unlockAction(auth, `${productionNumber}  ${reportDescription}`).catch(
        (error) => {
          handleError(error, "Failed to unlock the report");
          return;
        }
      );

      const needQualityRepSignature: boolean =
        !report.qualityRepresentiveSignature;
      const needWarehouseRepSignature: boolean =
        !report.warehouseRepresentiveSignature;
      if (status === "P") {
        await printLabel(report);

        if (needQualityRepSignature || needWarehouseRepSignature) {
          const users = (await getUsers(auth)).filter(
            (u) =>
              (needQualityRepSignature &&
                u.inspection ===
                  InspectorRole[InspectorRole.QualityRepresentive]) ||
              (needWarehouseRepSignature &&
                u.inspection ===
                  InspectorRole[InspectorRole.WarehouseRepresentive])
          );

          const subject = `Countersign ${reportName} report`;
          const body = `Dear Sir or Madam,<br/>Please countersign ${reportName} report.<br/>
          <a>https://csm.swagelokcentral.co.uk/${reportType}/${productionNumber}-${reportName}</a>`;

          const currentUser = user.info.name ?? user.fullName;

          users.forEach((user) => {
            if (user.email && currentUser !== user.name) {
              try {
                let email: EmailMessage = {
                  subject: subject,
                  body: body,
                  to: [{ address: user.email }],
                };
                sendEmail(auth, email);
              } catch (emailError) {
                handleError(emailError, "Failed to send email");
              }
            }
          });
        }
      }
      navigate(`/barcode/${sequenceNumber?.toLowerCase()}`);
    } catch (error) {
      handleError(error, "Failed to submit report");
    }
  };

  return (
    <StyledFactoryAcceptanceInspectionPage>
      {error ? (
        <div className="text-danger">
          <h1>Error: {error}</h1>
        </div>
      ) : (
        <Container fluid>
          <Row align="stretch">
            <h1 style={{ margin: "auto" }}>
              Factory Acceptance Test Checklist
            </h1>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>PRODUCTION NUMBER:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={productionNumber}
                placeholder="Scan production number"
                readOnly
              />
            </Col>
            <Col sm={1}>
              <ButtonComponent
                ref={(scope : ButtonComponent) => {
                  btnProductionNumber = scope;
                }}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanProductionNumberClick}
                created={() => {
                  if (btnProductionNumber) {
                    btnProductionNumber.element.setAttribute(
                      "title",
                      "Scan amob production number"
                    );
                  }
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>SEQUENCE NUMBER:</LabelText>
            </Col>
            <Col>{sequenceNumber}</Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>QUANTITY:</LabelText>
            </Col>
            <Col>
              <NumericTextBoxComponent
                value={quantity}
                min={1}
                onChange={(args: any) => {
                  setQuantity(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>DOCUMENT VERIFICATION</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Assembly Drawing No:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter assembly drawing number"
                value={assemblyDrawingNumber}
                onChange={(args: any) => {
                  setAssemblyDrawingNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Rev:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter revision"
                value={revision}
                readOnly={readOnly}
                onChange={(args: any) => {
                  setRevision(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="DocumentVerificationGrid"
              dataSource={documentCheckListItems}
              disabled={readOnly}
              height={50}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  template={documentCheckBoxTemplate}
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>VISUAL VERIFICATION</TitleLabelText>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="VisualVerificationGrid"
              dataSource={visualCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              //disabled={readOnly}
              height={320}
              allowResizing
              gridLines="Both"
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  template={visualCheckBoxTemplate}
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>
              3RD PARTY INSPECTION ACCEPTANCE TEST RECOMMENDATION
            </TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col>
              <LabelText>
                <b>Select recommendation in the box:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <ComboBoxComponent
                value={recommendation}
                disabled={readOnly}
                allowCustom={true}
                width="150"
                dataSource={recomendations}
                popupHeight="150"
                popupWidth="200"
                onChange={(args: any) => {
                  setRecommendation(args.value);
                }}
              ></ComboBoxComponent>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>1.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                The total rejection of the equipment, in which case a restart of
                the assembly
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>2.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                Partial rejection of the frame or canopies, in which case rework
                or modifications shall be completed
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>3.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                Approval of the frame or canopies assembly
              </SmallLabelText>
            </Col>
          </Row>
          {recommendation ===
            RecomendationType[RecomendationType.TotalRejection] ||
          recommendation ===
            RecomendationType[RecomendationType.PartialRejection] ? (
            <>
              <Row align="stretch">
                <TitleLabelText>
                  FACTORY ACCEPTANCE TEST NON-CONFORMANCE REPORTING
                </TitleLabelText>
              </Row>
              <Row align="stretch">
                <Col sm={3}>
                  <LabelText>
                    <b>BATCH IDENTIFICATION:</b>
                  </LabelText>
                </Col>
                <Col>
                  {batch && iteration ? `${batch}-${iteration}` : <></>}
                </Col>
              </Row>
              <Row align="stretch">
                <TitleLabelText>
                  FACTORY ACCEPTANCE TEST NON-CONFORMANCE REWORK VERIFICATION
                </TitleLabelText>
              </Row>
              <Row align="stretch">
                <Col sm={3}>
                  <LabelText>
                    <b>Non-Conformance Report Ref:</b>
                  </LabelText>
                </Col>
                <Col>
                  <TextBoxComponent value={nonConformanceReportRef} readOnly />
                </Col>
              </Row>
              <Row align="stretch">
                Provide brief description of rework here if recommendation is 2
                and possible rework can be carried out.
              </Row>
              <Row>
                <TextBoxComponent
                  readOnly={readOnly}
                  multiline={true}
                  placeholder="Provide brief description of the rework carried out here, if
                        recommendation is rework can be carried out."
                  value={reworkDescription}
                  // created={onCreate}
                  input={(args: any) => {
                    setReworkDescription(args?.value);
                  }}
                />
              </Row>
            </>
          ) : (
            <></>
          )}
          <Row align="stretch">
            <TitleLabelText>INSPECTOR SIGNATURE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{inspectorSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {inspectorSignDate !== undefined
                ? shortDateFormat(inspectorSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>QUALITY REPRESENTATIVE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{qualityRepresentiveSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {qualityRepresentiveSignDate !== undefined
                ? shortDateFormat(qualityRepresentiveSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>WAREHOUSE SIGNATURE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{warehouseRepresentiveSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {warehouseRepresentiveSignDate !== undefined
                ? shortDateFormat(warehouseRepresentiveSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <ButtonComponent
              disabled={!canSumbit}
              style={{ margin: "auto", width: "150px" }}
              cssClass="e-inherit"
              iconCss="e-icons e-save"
              onClick={onSubmit}
            >
              Submit
            </ButtonComponent>
          </Row>
        </Container>
      )}
    </StyledFactoryAcceptanceInspectionPage>
  );
};
